module.exports = __webpack_public_path__ + "packs/media/images/palestraVie-e3f60ec9ff50d94e36aa8b119484284e.jpg";